export type AddressModelFR = {
  adresse: string;
  complementAdresse: string;
  codePostal: string;
  ville: string;
  villeCodeInsee?: string;
  pays: string;
  latitude?: number;
  longitude?: number;
};

export type AddressModel = {
  address: string;
  additionalAddress: string;
  postalCode: string;
  city: string;
  cityCode?: string;
  country: string;
  latitude?: number;
  longitude?: number;
};

export const translateAddressModel = (am: AddressModelFR): AddressModel => {
  return {
    address: am.adresse,
    additionalAddress: am.complementAdresse,
    postalCode: am.codePostal,
    city: am.ville,
    cityCode: am.villeCodeInsee,
    country: am.pays,
    latitude: am.latitude,
    longitude: am.longitude,
  };
};

export const readableAddress = (a: AddressModel) => {
  return `${a.address}, ${a.postalCode}, ${a.city}`;
};
